import { StatusName } from "../../../../factories/statuses/enums/status.enum";
import { SubStatusModel } from "../../../../factories/statuses/models/status.model";

export const STATUS_COLORS: Record<
  Exclude<StatusName, StatusName.trial>,
  { dot: string; dotShadow: string; text: string }
> = {
  [StatusName.Ready]: {
    dot: "bg-[#3FABE5]",
    dotShadow: "bg-[#3FABE533]",
    text: "text-[#0E5C86]",
  },
  [StatusName.InProgress]: {
    dot: "bg-[#FAAF0E]",
    dotShadow: "bg-[#FAAF0E33]",
    text: "text-[#C58700]",
  },
  [StatusName.Waiting]: {
    dot: "bg-[#FF833D]",
    dotShadow: "bg-[#FF833D33]",
    text: "text-[#BC4B0C]",
  },
  [StatusName.Completed]: {
    dot: "bg-[#3ABA6D]",
    dotShadow: "bg-[#3ABA6D33]",
    text: "text-[#2D9D60]",
  },
  [StatusName.Scheduled]: {
    dot: "bg-[#1f2937]",
    dotShadow: "bg-[#1f293733]",
    text: "text-[#1f2937]",
  },
};

export const formatWorkTypeUsage = (count?: number) => {
  const normalizedCount = Number(count || 0);

  if (normalizedCount <= 0) {
    return "Not in any work type";
  }

  return `in ${normalizedCount} work type${normalizedCount === 1 ? "" : "s"}`;
};

export const isEmptyWorkTypeUsage = (count?: number) => Number(count || 0) <= 0;

export const getSubStatusAssignedWorkTypeIds = (subStatus: SubStatusModel) =>
  subStatus.serviceIds ?? [];

/**
 * Delete-status confirm text (QA batch 16, SET-014): says how many work items
 * use the status; they are moved to the picked status before it's deleted.
 */
export const subStatusDeleteText = (
  usage: { workCount: number } | undefined,
  isLoading: boolean,
) => {
  if (isLoading) return "Checking whether work items use this status…";
  if (!usage || !usage.workCount)
    return "Do you want to permanently delete this status?";
  const items = `${usage.workCount} work item${
    usage.workCount === 1 ? "" : "s"
  }`;
  return `Used by ${items}. Pick where to move ${
    usage.workCount === 1 ? "it" : "them"
  }, then the status is deleted.`;
};
